import { Strong } from '@radix-ui/themes'
import { type Fetcher } from '@remix-run/react'
import { type TFunction } from 'i18next'
import * as React from 'react'

import { StringToComponent } from '~/components/common/string-to-component.tsx'
import { type GetCustomer } from '~/models/ecommerce-providers/sylius/shop/fetch/customer/get-customer.ts'
import { type App } from '~/routes/_layout/root.component.tsx'
import { useNotify } from '~/utils/hooks/use-notify.ts'

/* -------------------------------------------------------------------------------------------------
 * useProfileNotify
 * -----------------------------------------------------------------------------------------------*/

type UseProfileNotifyProps = {
	setApp: React.Dispatch<React.SetStateAction<App>>
	fetcher: Fetcher
	t: TFunction<string, undefined>
	customer: GetCustomer
}

const useProfileNotify = ({
	setApp,
	fetcher,
	t,
	customer,
}: UseProfileNotifyProps) =>
	useNotify({
		...fetcher,
		setApp,
		translations: {
			success: {
				title: t('notify.logout.success.title'),
				description: (
					<StringToComponent text={t('notify.logout.success.description-$val')}>
						<Strong>{customer!.firstName}</Strong>
					</StringToComponent>
				),
			},
		},
	})

/* -----------------------------------------------------------------------------------------------*/

export { type UseProfileNotifyProps, useProfileNotify }
